import ApiService from "@/services/api.service";

const route = 'administrators';

const plans = {
    get(_administratorId, _id) {
        return new Promise((resolve, reject) => {
            ApiService.get(route + '/' + _administratorId + '/plans', _id).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    add(_administratorId, _module) {
        return new Promise((resolve, reject) => {
            ApiService.post(route + '/' + _administratorId + '/plans', _module).then(({ data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    edit(_administratorId, _id, _module) {
        return new Promise((resolve, reject) => {
            ApiService.patch(route + '/' + _administratorId + '/plans', _id, _module).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    rem(_administratorId, _id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(route + '/' + _administratorId + '/plans', _id)
                    .then(({ data }) => {
                        resolve(data);
                    }, (error) => {
                        reject(error);
                    });
        });
    }
};

export default plans;